import WalletConnectProvider from '@walletconnect/web3-provider'
import { errCodeHandle, ErrorInfo } from '../tools/error'
import { Wallet } from './wallet'

export class WalletConnect extends Wallet {
  constructor() {
    super()
  }

  /**
   * 连接钱包
   * @param {function} callback - 账号改变事件回调
   * @return {Promise<unknown>} 连接成功与失败
   */
  async connect(callback) {
    // 清除本地缓存
    window.localStorage.clear()
    // this._connector = new WalletConnectProvider({
    //   infuraId: process.env.VUE_APP_INFURA_ID,
    //   bridge: 'https://bridge.walletconnect.org'
    // })
    this._connector = new WalletConnectProvider({
      rpc: {
        [process.env.VUE_APP_CHAIN]: process.env.VUE_APP_RPC
      },
      chainId: parseInt(process.env.VUE_APP_CHAIN),
      network: 'binance',
      qrcode: true,
      qrcodeModalOptions: {
        mobileLinks: ['metamask', 'trust', 'f(x)Wallet']
      }
    })
    this._callback = callback
    this._addListener()

    let accounts = null
    try {
      // setTimeout(() => {
      //   const base = document.querySelector('#walletconnect-qrcode-modal')
      //   const tags = document.createElement('div')
      //   tags.classList.add('wcqr')
      //   tags.innerHTML = `
      //   <p class="wcqr-info">f(x)Wallet, imToken, Trust and more mobile wallets supported.</p>
      //   <a href="https://walletconnect.com/registry/apps" target="_blank" rel="noopener noreferrer" class="wcqr-link app-link font-bold">Learn More →</a>
      //   `
      //   base.insertBefore(tags, base.children[0])
      // }, 0)
      accounts = await this._connector.enable()
    } catch (e) {
      if (e.message === 'User closed modal') {
        errCodeHandle.go(220006)
        throw ErrorInfo(220006)
      } else {
        errCodeHandle.go(220003)
        throw ErrorInfo(220003)
      }
    }
    // this._connector
    //   .enable()
    //   .then(async res => {
    //     accounts = res
    //
    //     this.account = accounts[0]
    //
    //     this._getEthers()
    //
    //     let network = null
    //     try {
    //       network = await this._provider.getNetwork()
    //     } catch {
    //       errCodeHandle.go(220004)
    //       throw ErrorInfo(220004)
    //     }
    //     console.log('network', network)
    //     this.chainId = network.chainId
    //   })
    //   .catch(e => {
    //     if (e.message === 'User closed modal') {
    //       errCodeHandle.go(220006)
    //       throw ErrorInfo(220006)
    //     } else {
    //       errCodeHandle.go(220003)
    //       throw ErrorInfo(220003)
    //     }
    //   })

    this.account = accounts[0]

    this._getEthers()

    let network = null
    try {
      network = await this._provider.getNetwork()
    } catch {
      errCodeHandle.go(220004)
      throw ErrorInfo(220004)
    }
    console.log('network', network)
    this.chainId = network.chainId
  }

  /**
   * 断开连接 重置钱包
   */
  async disconnect() {
    this._connector.off('accountsChanged', this._cbAccountsChanged)
    this._connector.off('chainChanged', this._cbChainChanged)
    this._connector.off('connect', this._cbConnect)
    this._connector.off('disconnect', this._cbDisconnect)
    try {
      await this._connector.disconnect()
    } catch {
      this._initWallet()
      errCodeHandle.go(220004)
      throw ErrorInfo(220004)
    }
    this._initWallet()
  }

  /**
   * 获取chain Id
   * @return {Promise<number>}
   */
  async getChainId() {
    if (this._provider === null) {
      errCodeHandle.go(200001)
      throw ErrorInfo(200001)
    } else {
      const network = await this._provider.getNetwork()
      this.chainId = network.chainId
      return this.chainId
    }
  }

  // 绑定监听事件
  _addListener() {
    this._cbAccountsChanged = accounts => {
      console.log('accountsChanged', accounts)
      if (this.account !== null && this.account !== accounts[0]) {
        this.account = accounts[0]
        this._handleCallback(this._callback, 'accountsChanged', this.account)
      }
    }
    this._connector.on('accountsChanged', this._cbAccountsChanged)

    this._cbChainChanged = chainId => {
      console.log('chainChanged', chainId)
      if (this.chainId !== null && this.chainId !== chainId) {
        this.chainId = chainId
        this._handleCallback(this._callback, 'chainChanged', this.chainId)
      }
    }
    this._connector.on('chainChanged', this._cbChainChanged)

    this._cbConnect = () => {
      console.log('connect')
      this._handleCallback(this._callback, 'connect')
    }
    this._connector.on('connect', this._cbConnect)

    this._cbDisconnect = (code, reason) => {
      console.log('disconnect', code, reason)
      this._handleCallback(this._callback, 'disconnect')
    }
    this._connector.on('disconnect', this._cbDisconnect)
  }
}
